import { t } from 'i18n';
import React from 'react';
import { useProductDetailState } from 'contexts';
import { PolicyAndService, Information } from './PolicyAndService';
import { usePolicies } from 'hooks';
import { Shape } from '@teko/ds-desktop';

export const Policies = () => {
  const { product } = useProductDetailState();
  const { salePolicies, otherPolicies } = usePolicies(
    product?.sku || '',
    product?.seller?.id,
  );

  if (!product && !salePolicies?.length && !otherPolicies?.length) {
    return null;
  }

  return (
    <Shape paddingTop="s8">
      {salePolicies?.length || otherPolicies?.length ? (
        <Shape backgroundColor="white">
          {salePolicies?.length ? (
            <PolicyAndService
              title={t('Chính sách bán hàng')}
              information={salePolicies as Information[]}
              padding="s8"
            />
          ) : null}
          {otherPolicies?.length ? (
            <PolicyAndService
              title={t('Dịch vụ khác')}
              information={otherPolicies as Information[]}
              padding="s8"
            />
          ) : null}
        </Shape>
      ) : null}
    </Shape>
  );
};
